import React from 'react';

export const TickOneIcon = ({ className, ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="currentColor"
      className={className}
    >
      <path d="M4.5 11.5L0 5H3L4.5 6.73809L9.5 0.5H13L8.75 6L4.5 11.5Z" />
    </svg>
  );
};
